export const LOCALE_PREFIXES = [/^\/us(?=\/)/];

export const URL_NORMALISATION_RULES = [{ regex: /\/$/, replace: '' }];

export const LABEL_NORMALISATION_RULES = [
  { regex: /^\/?collections\//, replace: '' },
  { regex: /^all-/, replace: '' },
  { regex: /^\//, replace: '' },
  { regex: /-/g, replace: ' ' },
];

export const CAPITALISE_WORD_BOUNDARIES = true;

export const COLLECTIONS_VARIABLE = 'collections';
export const PRODUCTS_VARIABLE = 'products';
export const SHOP_BY_VARIABLE = 'shop-by';
export const SIZE_VARIABLE = 'size';

export const BREADCRUMB_SEGMENTS_TO_EXCLUDE = new Set([
  'collections',
  'shop-by',
  'size',
]);

export const SHOP_BY_SIZE_LABELS = new Set([
  'Shop By Size Bras',
  'Shop By Size Swimwear',
]);
